import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f2675028")

_pushScopeId("data-v-f2675028")
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.link && _ctx.team)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          class: "team__router",
          to: `/teams/${_ctx.team.name}`
        }, {
          default: _withId(() => [
            _createVNode("div", {
              class: "team__badge",
              style: _ctx.badgeStyle
            }, [
              (_ctx.hasCustomLogo)
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    src: _ctx.team.logo,
                    class: "icon-team-logo"
                  }, null, 8, ["src"]))
                : (_openBlock(), _createBlock("span", _hoisted_1, _toDisplayString(_ctx.formattedText), 1))
            ], 4)
          ]),
          _: 1
        }, 8, ["to"]))
      : (_openBlock(), _createBlock("div", {
          key: 1,
          class: "team__badge",
          style: _ctx.badgeStyle
        }, [
          (_ctx.hasCustomLogo)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                src: _ctx.team?.logo,
                class: "icon-team-logo"
              }, null, 8, ["src"]))
            : (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.formattedText), 1))
        ], 4))
  ]))
})